"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Reward API for client FE
 * Reward API
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: cons.pompili@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalTypeEnum = void 0;
/**
 * ### Approval Type Enum:  * `NONE` - No approval is required  * `STANDARD` - Standard approval, user must provide approve with data  * `LIGHT` - Light approval, user must provide only if approve or not
 * @export
 * @enum {string}
 */
var ApprovalTypeEnum;
(function (ApprovalTypeEnum) {
    ApprovalTypeEnum["None"] = "NONE";
    ApprovalTypeEnum["Standard"] = "STANDARD";
    ApprovalTypeEnum["Light"] = "LIGHT";
})(ApprovalTypeEnum = exports.ApprovalTypeEnum || (exports.ApprovalTypeEnum = {}));
